// ======================================================================
// File Name       : InputConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal, Col } from 'react-bootstrap';
import RenderField from '../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../constants/index';

class InputConfirmDialog extends React.Component {
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
  // START #5611
    const isDisableInput = this.props.disableInput;
  // END #5611
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={this.props.mdSize}
        animation={this.props.animation}
        style={style}
      >
        {this.props.title &&
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        }
        <Modal.Body className="text-center">
          <Col sm={12}>{this.props.content}</Col>
          <Col sm={12} className="margin-top-10">
            {!isDisableInput ? (
              <RenderField
                type="textarea"
                // START #5611
                label="差し戻し理由"
                rows={9}
                // END #5611
                name="denialReason"
                disabled={isDisableInput}
                validates={[VALIDATE_TYPE.REQUIRED]}
                maxLength={1024}
              />
            ) : (
              <p className="margin-top-10 text-left">{this.props.value}</p>
            )}
          </Col>
        </Modal.Body>

        <Modal.Footer className="text-center">
          <Button
            className=" margin-right-10 btn-96"
            variant="default"
            onClick={this.props.onCancel}
          >
            キャンセル
          </Button>
          <Button className=" margin-left-10 btn-96" variant="primary" onClick={this.props.onOK}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

InputConfirmDialog.defaultProps = { animation: true };
export default InputConfirmDialog;
